import { ModelBase } from '../../../core/model/model-base';

export class B2CInvoiceImportEvent extends ModelBase {
  constructor() {
    super();
    Object.defineProperties(this, {
      _bankSentDate: { enumerable: false, writable: true },
      _bankReplyDate: { enumerable: false, writable: true },
      _importDate: { enumerable: false, writable: true },
    });
  }

  private _bankSentDate: Date;
  private _bankReplyDate: Date;
  private _importDate: Date;

  get bankSentDate(): Date {
    return this._bankSentDate;
  }
  set bankSentDate(value: Date) {
    this._bankSentDate = this.coerceDate(value);
  }

  get bankReplyDate(): Date {
    return this._bankReplyDate;
  }
  set bankReplyDate(value: Date) {
    this._bankReplyDate = this.coerceDate(value);
  }

  get importDate(): Date {
    return this._importDate;
  }
  set importDate(value: Date) {
    this._importDate = this.coerceDate(value);
  }

  rejectText: string;
  statusText: string;
}
